import type Asset from '../asset';
import { FilterJSON, isUserAssignedFilterJSON, SelectedUserID } from './types';
import FilterOption from './filterOption';

const hasNoAssignees = ( asset: Asset ) => asset.assignees.length === 0;

const matchSomeAssignees = ( asset: Asset, userIDs: number[] ) => {
	const assetAssigneeIDs = asset.assignees.map( assignee => assignee.id );
	return assetAssigneeIDs.some( id => userIDs.includes( id ) );
};

export default class UserAssignedFilter implements FilterOption {
	ids: SelectedUserID[];

	constructor( ids: SelectedUserID[] ) {
		this.ids = ids;
	}

	get id() {
		return `user-assigned-${this.ids.join( '_' )}`;
	}

	get filterAmount() {
		return this.ids.length;
	}

	get isEmpty() {
		return this.ids.length === 0;
	}

	isPassedBy( asset: Asset ) {
		return (
			this.isMatchingNotAssigned && hasNoAssignees( asset )
		) || matchSomeAssignees( asset, this.idsWithoutNotAssigned );
	}

	toJson() {
		return { assigned_to: { ids: this.ids, match_all: false } };
	}

	static fromJson( json: FilterJSON ) {
		return isUserAssignedFilterJSON( json )
			? new UserAssignedFilter( json.assigned_to.ids )
			: null;
	}

	private get isMatchingNotAssigned() {
		return this.ids.includes( null );
	}

	private get idsWithoutNotAssigned() {
		return this.ids.filter( id => id !== null ) as number[];
	}
}
